import { NotificationsTranslations } from '../en-US/notifications.translations';

export const notificationsTranslations: NotificationsTranslations = {
  title: 'Notificações',
  pageTitle: 'Notificações',
  pageDescription: 'Ver e gerir as suas notificações',
  settingsTitle: 'Definições de notificações',
  settingsPageTitle: 'Definições de notificações',
  settingsPageDescription: 'Gerir as suas preferências de notificações',
  settings: 'Definições',
  markAsRead: 'Marcar como lido',
  markAllAsRead: 'Marcar tudo como lido',
  delete: 'Eliminar',
  more: 'mais',
  noNotifications: 'Sem notificações',
  emptyDescription: 'Ainda não tem notificações',
  errorLoading: 'Erro ao carregar notificações',
  errorLoadingSettings: 'Erro ao carregar definições de notificações',
  tryAgain: 'Por favor, tente novamente mais tarde',
  enableNotifications: 'Ativar notificações',
  enablePromptMessage: 'Mantenha-se atualizado com as últimas avaliações, gostos e seguidores ativando as notificações.',
  remindLater: 'Lembrar mais tarde',
  enable: 'Ativar',
  stayUpdated: 'Mantenha-se atualizado',
  enableDescription: 'Ative as notificações para se manter informado sobre novas avaliações, gostos e seguidores.',
  pushNotifications: 'Notificações push',
  pushDescription: 'Receba notificações no seu dispositivo',
  emailNotifications: 'Notificações por e-mail',
  emailDescription: 'Receba notificações por e-mail',
  enableAllNotifications: 'Ativar todas as notificações',
  masterToggleDescription: 'Ativar/desativar todas as notificações',
  notificationTypes: 'Tipos de notificações',
  types: {
    reviewLiked: 'Avaliação com gosto',
    reviewLikedDescription: 'Receba uma notificação quando alguém gostar da sua avaliação',
    newPlaceReviews: 'Novas avaliações de locais',
    newPlaceReviewsDescription: 'Receba uma notificação quando um novo local for avaliado',
    newFoodReviews: 'Novas avaliações de comida',
    newFoodReviewsDescription: 'Receba uma notificação quando uma nova comida for avaliada',
    newReviewCreated: 'Nova avaliação criada',
    newReviewCreatedDescription: 'Receba uma notificação quando uma nova avaliação for criada',
    userFollowed: 'Utilizador seguido',
    userFollowedDescription: 'Receba uma notificação quando um utilizador o seguir',
  },
}; 

export default notificationsTranslations;
